export default class DefaultImage extends React.Component {
  state = {
    error: null,
  };

  onError = (error) => {
    this.setState({ error });
  };

  getSrc = () => {
    const { error } = this.state;
    const { src, defaultSrc } = this.props;

    if (error || !src) {
      return defaultSrc;
    } else {
      return src;
    }
  };

  render() {
    const { defaultSrc: _defaultSrc, ...props } = this.props;

    if (this.state.error || !this.state.src) {
      if (this.props.default) return this.props.default;

      return <img {...props} src={this.getSrc()} onError={this.onError} />;
    }
  }
}

DefaultImage.defaultProps = { defaultSrc: '/default.png' };
